/**
 * Simplecast CMS episode PATCH capabilities (public CMS API).
 * Unsupported fields must not render Integration data checkboxes (SPP-689).
 * Chapters: not documented on PatchEpisodeRequestDto — hide until confirmed.
 */
export const SIMPLECAST_PUSH_CAPABILITIES = {
  hasMonetisation: true, // markers
  hasTags: true, // keywords
  hasChapters: false,
  hasSummary: true, // description
} as const;

export type SimplecastPushCapabilityKey =
  keyof typeof SIMPLECAST_PUSH_CAPABILITIES;
